import React, {useEffect, useState} from 'react';
import CustomSelect from "../form/CustomSelect";
import { GetCountries } from "../../api/offices/GetCountries";
import {useTranslation} from "react-i18next";

const CountrySelect = ({onChange, onlyCountry, excludeCountries, ...props}) => {

    const { t } = useTranslation();

    const [availableCountries, setAvailableCountries] = useState([]);

    useEffect(() => {
        const setCountries = async function (){
            try {
                let data = await GetCountries();
                if (excludeCountries && excludeCountries.length > 0) {
                    data = data.filter(country => !excludeCountries.includes(country.label));
                }
                if (onlyCountry && onlyCountry.length > 0) {
                    data = data.filter(country => onlyCountry === country.label);
                }
                setAvailableCountries(data);
            } catch (err){
                console.log("Error fetching user roles: " + err);
            }
        }
        setCountries();
    }, []);

    return (
        <CustomSelect
            placeholder={<div>{t("Select country")}</div>}
            options={availableCountries}
            onChange={onChange}
            value={availableCountries.find(option =>
                option.value && props.value && option.value.toLowerCase() === props.value.toLowerCase()
            )}
        />
    );
};

export default CountrySelect;
